import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useSMSEnabled = () => {
  return useQuery({
    queryKey: ['sms-enabled'],
    queryFn: async () => {
      const { data } = await supabase
        .from('sms_settings')
        .select('is_enabled')
        .maybeSingle();
      return data?.is_enabled || false;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
